import { CommandType } from "~app/common/services/cqs/CommandType";
import { ProduktionsmallBaseCommand } from "~app/features/planera/commands/ProduktionsmallBaseCommand";

export class AddProduktionsmallCommand extends ProduktionsmallBaseCommand {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "AddProduktionsmallCommand";

    constructor(guid: string, benamning: string, vardekap: boolean, ckLeverantorId?: number) {
        super(AddProduktionsmallCommand.$type, CommandType.Insert);
        this.guid = guid;
        this.benamning = benamning;
        this.vardekap = vardekap;
        this.ckLeverantorId = ckLeverantorId;
    }
}
